/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Indicates whether the product is bookable via external systems like boardportal
 */
export const SpaProductExternalAccessDTO = {
    BOOKABLE: 'BOOKABLE',
    VISIBLE: 'VISIBLE',
    HIDDEN: 'HIDDEN'
} as const;
export type SpaProductExternalAccessDTO = typeof SpaProductExternalAccessDTO[keyof typeof SpaProductExternalAccessDTO];

